import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { Box } from '@rebass/grid';
import Icon from 'app/ui_components/Icon';
import SideItem from 'app/ui_components/SideItem';

class Improvements extends React.Component {
  static propTypes = {
    failed: PropTypes.array.isRequired,
  };

  goToItem = e => {
    const name = e.target.name;
    ReactGA.event({
      category: 'Results',
      action: 'Click',
      label: `improvement-item-${name}`,
    });
    document.getElementById(name).scrollIntoView({
      behavior: 'smooth',
    });
  };

  render() {
    const { failed } = this.props;
    return (
      <SideItem>
        <Box width={1 / 1} p={16}>
          Your Top Improvements
        </Box>
        {failed.map(({ label, id }) => (
          <Box width={[1 / 2]} key={id} pt={20} pb={'5px'}>
            <Icon
              graphic={label}
              small={true}
              onClick={this.goToItem}
              name={id}
              hover={true}
            />
            <div style={{ paddingTop: '5px', fontSize: '14px' }}>{label}</div>
          </Box>
        ))}
      </SideItem>
    );
  }
}

const mapStateToProps = ({ grade: { top_failed: failed } }) => ({ failed });

export default connect(
  mapStateToProps,
  null,
)(Improvements);
